import { Alert, Button, Icon } from '@economic/taco';
import { Field, Form } from '~/app/shared/components/Form';
import { t, Trans } from '@lingui/macro';
import { refreshCurrentLegacyFrame, useHostRefetch } from '@economic/react-app';
import ExternalLink from '~/app/shared/components/ExternalLink';
import { getBankAccountStepValidationSchema, getCreateCompanyBody } from '../../utils/utils';
import { BankAccountStepState, GetCurrentCompanyBankInformationResponse } from '../../types';
import { useCreateCompany } from './useCreateCompany';
import { usePayrollOnboardingContext } from '../../context/OnboardingContext';

export const BankAccountStepWhenSENumber = ({ bankData }: { bankData: GetCurrentCompanyBankInformationResponse }) => {
    const { companyInfoStepState, onNext, setIsDialogLoading } = usePayrollOnboardingContext();
    const { trigger: triggerCompanyCreation } = useCreateCompany();
    const refetchHost = useHostRefetch();

    const onSubmit = (bankAccountStepState: BankAccountStepState) => {
        const companyToCreate = getCreateCompanyBody(bankAccountStepState, companyInfoStepState);
        setIsDialogLoading(true);

        triggerCompanyCreation({ company: companyToCreate })
            .then(() => {
                refreshCurrentLegacyFrame();
                refetchHost();
                onNext();
            })
            .finally(() => {
                setIsDialogLoading(false);
            });
    };
    return (
        <>
            <p className="text-sm text-center mb-5">
                <Trans>
                    In order to allow us to send money on your behalf, you need to apply manually for the transfer agreement in
                    Mastercard so your company's bank account will be validated.
                </Trans>
            </p>
            <Form
                onSubmit={onSubmit}
                initialData={{ accountNo: bankData?.bankAccount, regNo: bankData?.bankSortCode }}
                key="payroll-onboarding-step3-form"
                skipNotifications
                validationSchema={getBankAccountStepValidationSchema({ isCVR: false })}>
                <div className="flex flex-wrap">
                    <div className="flex pl-3 w-full justify-center">
                        <div className="flex w-3/5">
                            <Field.Text id="regNo" name="regNo" label={t`Reg no.`} required fieldClassName="w-1/4 mr-2" />
                            <Field.Text
                                id="accountNo"
                                name="accountNo"
                                label={t`Account no.`}
                                fieldClassName="w-3/4"
                                type="text"
                                required
                            />
                        </div>
                    </div>
                    <div className="text-center w-full text-sm pl-5 mb-6">
                        <Trans>You can apply now or later for the</Trans>{' '}
                        <ExternalLink openNewTab href="https://overfoerselsservice.mastercard.com/">
                            <Trans>transfer agreement in Mastercard</Trans>
                        </ExternalLink>
                        <Icon name="link-external" className="ml-1 !w-5" />
                    </div>
                    <Alert state="warning" className="mt-2">
                        <Trans>You can always apply to change your bank account from the company page.</Trans>
                    </Alert>
                    <div className="flex w-full justify-end mt-6">
                        <Button type="submit" appearance="primary">
                            <Trans>Next</Trans>
                        </Button>
                    </div>
                </div>
            </Form>
        </>
    );
};
